import { SxStyleProp } from 'theme-ui';
import Theme from '../../gatsby-plugin-theme-ui';

export const promoBlockStyle: { [k: string]: SxStyleProp } = {
  card: {
    ...Theme.cards.primary,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    flexDirection: 'column',
    display: 'flex',
    position: 'relative',
    justifyContent: 'flex-end',
    minHeight: '300px',
    transform: 'translate(0, 0)',
    transition: 'transform 0.3s ease-in-out',

    '&:hover': {
      transform: 'translate(-1px, -1px)',
    },

    '.card-one': { gridArea: 'bigOne' },
    '.card-two': { gridArea: 'bigOne' },

    '.card-category': {
      color: Theme.colors?.grayMedium[100],
      display: 'block',
      fontFamily: Theme.fonts.robotoSlab,
      fontWeight: '700',
      mb: '10px'
    },

    '.card-excerpt': {
      ...Theme.text.body2
    },

    '.card-info': {
      backgroundColor: 'white',
      padding: '20px',
      position: 'relative',
    },
    '.card-info::after': {
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0), #fff)',
      bottom: 'calc(100% - 1px)',
      content: '""',
      display: 'block',
      height: '50px',
      left: '0',
      position: 'absolute',
      width: '100%',
    },

    '.card-title': {
      display: 'block',
      ...Theme.text.h4
    }
  },
  cardGrid: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-evenly',
    width: '100%',

    '> div': {
      width: 'calc(50% - 15px)',
    },

    '@media only screen and (max-width: 768px)': {
      '> div': {
        width: '100%',
      },
    },
  },
  cardLink: {
    textDecoration: 'none',
  },
  container: {
    '@media only screen and (max-width: 1024px)': {
      px: '20px'
    },
  },
  grid: {
    display: 'grid',
    gridTemplateAreas:`
      'title'
      'bigOne'
    `,
    gap: '30px',
    justifyContent: 'center',

    '> a, > article': {
      maxWidth: '100%',
    },

    '&.has--one-cards': {
      '.card-body': {
        position: 'relative',
      }
    },

    '&.has--two-cards': {
      gridTemplateAreas:`
        'title title'
        'bigOne bigTwo'
      `,

      '@media only screen and (max-width: 1024px)': {
        gridTemplateAreas:`
          'title'
          'bigOne'
          'bigTwo'
      `},
    },

    '&.has--three-cards': {
      gridTemplateAreas:`
        'title title'
        'bigOne miniOne'
        'bigOne miniTwo'
      `,
    },

    '&.has--four-cards': {
      gridTemplateAreas:`
        'title title'
        'bigOne miniOne'
        'bigOne miniTwo'
        'bigOne miniThree'
      `,
    },
  },
  title: {
    gridArea: 'title',
    textAlign: 'center',
    ...Theme.text.h2,
  }
};
